import type { PropsWithChildren } from "react";
import { IoChevronForward } from "react-icons/io5";

import { cn } from "shared/utils/cn";

type Props = { withArrow?: boolean; className?: string; onClick?: () => void };

export const Panel = (props: PropsWithChildren<Props>) => {
  const { className, withArrow = true, children, onClick } = props;
  return (
    <div
      className={cn(
        "bg-oil relative block w-full items-center rounded-xl border-l border-[#49ACFF] p-3 transition-colors",
        onClick && "cursor-pointer hover:brightness-110",
        withArrow && "pr-8",
        className
      )}
      onClick={onClick}
    >
      {children}
      {withArrow && (
        <IoChevronForward className="absolute top-1/2 right-4 size-4 -translate-y-1/2 text-white/40" />
      )}
    </div>
  );
};
